<template>
  <Grid>
    <Col12>
      <TransactSSOCheckbox :institution-id="institutionId" @update:checked="handleCheckedChange" />
    </Col12>
    <Col12 v-if="showInstitution">
      <Divider class="mt-1" />
      <TransactSSODropdown />
    </Col12>
  </Grid>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { useField, useFieldValue } from 'vee-validate';
import TransactSSOCheckbox from './transact-sso-checkbox/TransactSSOCheckbox.vue';
import TransactSSODropdown from './transact-sso-dropdown/TransactSSODropdown.vue';

const institutionId = useFieldValue<string | undefined>('transactSSO.institutionId');
const useSSO = useFieldValue<boolean>('keystore.use_sso');

const { setValue: setUseSSO } = useField<boolean>('keystore.use_sso');
const { setValue: setInstitutionId } = useField<string | undefined>('transactSSO.institutionId');

// Show dropdown if checkbox is checked OR if institutionId exists
const showInstitution = computed(() => {
  return Boolean(useSSO.value) || Boolean(institutionId.value);
});

const handleCheckedChange = (checked: boolean) => {
  setUseSSO(checked);
  // Clear institutionId when checkbox is unchecked
  if (!checked) {
    setInstitutionId(undefined);
  }
};
</script>
